export const proj_names = {
    green_garden:'גנים ירוקים',
    geulim:'הגאולים 15',
    geulim_5:'הגאולים 5',
    ground_floor:'גנים ירוקים - צמודי קרקע',
    migdal:'פרויקט במושבה מגדל'

}

export const nav_subjects = {
    explanation:"על הפרוייקט",
    neighborhood:"על השכונה",
    specification:"מפרט",
    imaging:"דגמים",
    above:"מבט על",
    simulation:"הדמיות",
    location:"מיקום",
}